import { adminPrefix } from "../../constants";

export const settingsApi = {
  FETCH_SETTINGS: adminPrefix + "settings",
  UPDATE_SETTING: adminPrefix + "setting/update",
};
